import { render, staticRenderFns } from "./section-products.vue?vue&type=template&id=5e25c4a6&scoped=true&"
import script from "./section-products.vue?vue&type=script&lang=js&"
export * from "./section-products.vue?vue&type=script&lang=js&"
import style0 from "./section-products.vue?vue&type=style&index=0&id=5e25c4a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e25c4a6",
  null
  
)

export default component.exports